import { render, staticRenderFns } from "./POPDouble.vue?vue&type=template&id=d19f46b0&scoped=true"
import script from "./POPDouble.vue?vue&type=script&lang=js"
export * from "./POPDouble.vue?vue&type=script&lang=js"
import style0 from "./POPDouble.vue?vue&type=style&index=0&id=d19f46b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f46b0",
  null
  
)

export default component.exports